import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { updateFields, updateFormProperties } from 'apps/auth/actions/formAction';
import { updateHeaderGrayTitle, updateHeaderTitle } from 'apps/auth/actions/messageAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { PHONE_COUNTRY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { LOGIN } from 'apps/auth/constants/UrlConstants';
import { useApp, useExtra, useFields, useLanguage, useLogin, usePageMessages } from 'apps/auth/hooks/selectors';

import FillProfile from './FillProfile';
import { SuccessStatus } from './SuccessStatus';
import WaitingListDisclaimer from './WaitingListDisclaimer';

const DISCLAIMER = 'DISCLAIMER';
const FORM = 'FORM';
const SUCCESS = 'SUCCESS';
const EMAIL = 'email';

const WaitingList = (props) => {
    const { country } = useApp();
    const { allCountries } = useExtra();
    const fields = useFields(props.formName);
    const { lang } = useLanguage();
    const { countryCode } = useLogin();
    const { waitingListHeaderTitle, waitingListHeaderGrayTitle, waitingListSuccessTitle } = usePageMessages();
    const [view, setView] = useState(props.showDisclaimer ? DISCLAIMER : FORM);

    useEffect(() => {
        if (!props.showDisclaimer) {
            props.updateFormProperties(props.formName, '/check-phone.action?action=registration');
        }
    }, [props.showDisclaimer]);

    const sendEvent = useCallback(
        (event) => {
            const phoneCountry = allCountries?.find(({ code }) => code === countryCode);
            const countryName = phoneCountry?.nameEn;
            amplitude.getInstance().logEvent(event, { [PHONE_COUNTRY]: countryName });
        },
        [allCountries, countryCode],
    );

    const notifyMe = () => {
        const newFields = { ...fields };
        Object.values(newFields).forEach((field) => {
            field.visible = field.name === EMAIL;
        });
        props.updateHeaderTitle(waitingListHeaderTitle);
        props.updateHeaderGrayTitle(waitingListHeaderGrayTitle);
        props.updateFormProperties(props.formName, '/waiting/list/enter-email.action');
        props.updateFields(props.formName, newFields).then(() => {
            setView(FORM);
        });
    };

    const submitHandler = (fields, json) => {
        if (json && json.errors && Object.keys(json.errors).length === 0) {
            setView(SUCCESS);
        }
    };

    const onBackIconClick = (e) => {
        e.preventDefault();
        setView(DISCLAIMER);
    };

    return (
        <>
            {view === DISCLAIMER && (
                <WaitingListDisclaimer
                    onBackIconClick={props.onBackIconClick}
                    showSvg={true}
                    formName={props.formName}
                    disclaimerAgreeClick={notifyMe}
                    popupRef={props.popupRef}
                    sendEvent={sendEvent}
                />
            )}
            {view === FORM && (
                <CommonPage backUrl={LOGIN} isTagA onClickIcon={onBackIconClick}>
                    <FillProfile
                        fromWaitingList={true}
                        onSubmitHandler={submitHandler}
                        formName={props.formName}
                        getFillProfileForms={props.getFillProfileForms}
                        sendEvent={sendEvent}
                    />
                </CommonPage>
            )}
            {view === SUCCESS && <SuccessStatus country={country} lang={lang} successTitle={waitingListSuccessTitle} sendEvent={sendEvent} />}
        </>
    );
};

export default connect(null, { updateHeaderTitle, updateHeaderGrayTitle, updateFields, updateFormProperties })(WaitingList);
